const UrlLinks = {
  baseUrl: "https://qaapieflex.okaygo.in/",
  // baseUrl: "https://apieflex.okaygo.in/",
  webBaseUrl: "https://qa.okaygo.in/",
  // webBaseUrl: "https://okaygo.in/",
  workerExecutionUrl: "https://task.okaygodev.in/org/worker_view",
  taskExecution:{
    taskExecutionUrl: "https://uat.okaygoprod.in/org/process_okaygo",
    // taskExecutionUrl: "https://task.okaygodev.in/org/process_okaygo",
    newTaskExecutionBaseUrl: "https://qahiring.okaygo.in/task/te/api/te/",
    // newTaskExecutionBaseUrl: "https://task-execution-backend.okaygo.in/task/te/api/te/",
    workflowViewUrl: "https://dev.d2tfhsvdogl5it.amplifyapp.com/task",
    // workflowViewUrl: "https://task-execution.okaygo.in/task",
    taskExecutionLogin: "hiring-flow/user-login",
  },
  hiringFlow:{
    hiringFlowAuthUrl: "https://qahiring.okaygo.in/api/auth/login",
    // hiringFlowAuthUrl: "https://hiring.okaygo.in/api/auth/login",
    hiringFlowRefreshUrl: "https://qahiring.okaygo.in/api/auth/refresh",
    // hiringFlowRefreshUrl: "https://hiring.okaygo.in/api/auth/refresh",
    hiringFlowCreateUrl: "https://qahiring.okaygo.in/api/flows",
    // hiringFlowCreateUrl: "https://hiring.okaygo.in/api/flows",
    hiringFlowViewUrl: "https://dev.d3q8u3m02wxohw.amplifyapp.com/project",
    // hiringFlowViewUrl: "https://hiring-flow.okaygo.in/project",
  },
  checkAdmin: "user/checkAdminUser",
  wiproReprt: "ezeDox/wipro/report",
  treeboReprt: "ezeDox/treebo/report",
  amazonReport: "ezeDox/amazom/report",
  clientReport: "ezeDox/clients/report",
  checkAdminUserNameV2: "user/checkAdminUserNameV2",
  saveAdminUserName: "user/saveAdminUserName",
  getEmail: "user/getEmailHRBP?email=",
  sendOtp: "/user/sendOTP",
  verifyOtp: "/user/verifyOTP",
  verifyHubName: "/user/isHubValid",
  registerHubLocation: "/user/registerHubLocation",
  messageTemplates: "popups/getTemplates",
  getMessageBody: "popups/getMessageBody",
  sendMsg: "/popups/sendMessages",
  sendCustomMsg: "/popups/sendCustomNotification",
  sendMsgToAll: "/popups/sendMessage/all",
  getPartner: "/configmaster/getPartners",
  getZonalManager: "/configmaster/getZonalManager",
  assignVerifier: {
    listing: "verifier/assignmentListing",
    assign: "verifier/update",
  },
  verificationAPIs: {
    listing: "docsVerification/getVerificationListing",
    listingV2: "docsVerification/getVerificationListingV2",
    getPhotoVerificationListing: "docsVerification/getPhotoVerificationListing",
    verificationProfile: "docsVerification/getVerificationDataByUserId",
    updateVerification: "docsVerification/manualDocsVerification",
  },
  workerUrls: {
    allowDocEdit: "/worker/allowDocEdit",
    workerLedgerListing: "ledger/getWorkerLedger",
    particularWorkerLedgerListing: "ledger/getWorkerLedgerInvoiceList",
    updatePennyTestingStatus: "worker/recheckBankDetail",
    lastAppliedHistory: "workerdata/getJobAppliedHistory?userId=",
    bgvStatusList: "bgv/getStatus?userId=",
    uploadTcsMpaWorkers: "/uploadData/uploadTcsMpaWorkers",
    triggerBGV: "bgv/createProfile?userId=",
    leadCities: "leads/getLeadCities?key=",
    reteriveLastSms: "worker/getLastSmsOfUser",
    editEntity: "workerdata/editEntities?",
    Invoicedetails: "/uploadData/uploadWorkerInvoiceDetailsV3?insertedBy=",
    uploadPayoutAutomation: "/uploadData/uploadPayoutAutomation?insertedBy=",
    workerListing: "worker/listing",
    workerListingV3: "/worker/listing/v3",
    workerDataListing: "/workerdata/listing",
    leadDataListing: "/workerdata/getLeadDataListing",
    workerDataListingv3: "/workerdata/listingV2",
    leadDataListingv3: "/workerdata/getLeadDataListingV2",
    workerView: "worker/listing?user_id=",
    workerViewV3: "workerdata/listing?user_id=",
    allWorkerListing: "worker/allRecords",
    editWorkerHRBPDetails: "workerdata/editHRBPSection",
    docList: "user/getUserDoc?user_id=",
    activateWorker: "worker/activateWorker",
    hubBasedFacilityList: "user/getHubs?userId=",
    facilityList: "worker/getFacilityByKey?key=",
    rateCardList: "worker/getDistinctRateCardByZone?zone=",
    uploadVacoOnboardingExcel: "/uploadData/uploadVacoWorker?insertedBy=",
    tagUserMpa: "/uploadData/tagUserMpa",
    uploadTcsAllotment: "uploadData/uploadTcsAllotment",
    uploadOnboardingExcel:
      "uploadData/uploadExcelForOkaygoIdCreation?insertedBy=",
    uploadOnboardingExcelV2:
      "uploadData/uploadExcelForOkaygoIdCreation/V2?insertedBy=",
    uploadOffboardingExcel: "uploadData/offBoardWorkersV2?userId=",
    updateLeader: "worker/leaderfunctionality",
    generateWeeklyInvoice: "/worker/generateWeeklyInvoice",
    uploadDocLink: "user/getDocLink?user_id=",
    uploadDocument: "user/uploadDocument?inserted_by=",
    // new added
    offBoardWorkers: "uploadData/V3/offBoardWorkers?userId=",
    uploadMettlAssessor: "workermaster/uploadMettlWorker?",
    uploadInsuranceCards: "workermaster/uploadInsuranceCards?",
    //integrate these
    getExistingLeadDetails: "workerdata/getLeadDataListing?user_id=",
    uploadHubs: "/hub/add",
    // here
    uploadGroupFlexExcel:
      "/uploadData/uploadExcelForOkaygoIdCreationWithGroupflexId?insertedBy=",
    bankDetails: "worker/getBankDetails?user_id=",
    editContact: "worker/editWorkerContacts",
    workerReactivation: "worker/changeWorkerStatusFromAdmin",
    workerWithoutCasperId: "worker/allWorkerCasper",
    uploadCasperOnboardingData: "upload/uploadWorkerCasperId",
    downloadAgreementOnResponse: "worker/createWorkerAgreementCopy?batchNo=",
    emailAgreements: `worker/sendAgreementEmail?inserted_by=${localStorage.getItem(
      "userID"
    )}&user_ids=`,
    workerDataHubs: "/configmaster/getActiveHubs",
    workerDataHubCity: "/configmaster/getFacilityCity",
    leadSourceList: "leads/getLeadSourceList",
    genderList: "configmaster/?category_type=gender&type_key=gender",
    languagesList: "configmaster/?category_type=language&type_key=language",
    assetsList: "configmaster/?category_type=ownership&type_key=ownership",
    qualificationList:
      "configmaster/?category_type=qualification_type&type_key=qualification_type",
    verticalList:
      "configmaster/?category_sub_type=lead_category&category_type=user_category",
    getAreaByPinCode: "worker/getAreaByPinCode?key=",
    workerDataHubState: "/configmaster/getFacilityStates",
    recruiterList: "/recruiter/getAllRecruiter?noPaging=1",
    workerWithoutClientCreatedIds: `workerdata/notFilledClientWorkerDataIds?partnerName=`,
    getInsuranceTagsExport: `workermaster/getInsuranceTagsExport?partnerId=`,
    uploadExcelForMultiplePartner2:
      "/uploadData/uploadExcelForMultiplePartner?insertedBy=",
    uploadCasperOnboardingData2:
      "uploadData/uploadClientWorkerDataIds?partnerName=",
    uploadInsuranceTags: "workermaster/uploadInsuranceTags?insertedBy=",
    hubListing: "/hub/getHubsByClient",
    uploadExcelForLMD: "/uploadData/uploadExcelForMultiplePartner?insertedBy=",
    uploadExcelForNonLMD: "/uploadData/uploadNonLmdWorker?insertedBy=",
    getAllAgreedProjectByUserId: "/task-model/getAllAgreedProjectByUserId",
    getAgreementByUserId: "/task-model/getAgreementByUserId",
  },
  clients: {
    addNewCompany: "clients/saveNewClient",
  },
  paymentUrls: {
    financeAdmin: "user/checkFinanceUser?user_id=",
    getCustomInvoiceTemplate: "payments/getCustomInvoiceTemplate",
    paymentOnHold: "payments/holdPayments",
    paymentListing: "payments/listing",
    paymentListingMultiClientV2: "workerdata/paymentDataListingV2",
    paymentunHold: "payments/undoHoldPayments",
    triggerPayment: "payments/triggerBulkPayments",
    updatePaymentStage: "payments/updateStage",
    updateRetriggerPaymentStage: "payments/retriggerInvoicePayments",
    uploadInvoice: "/uploadData/uploadCustomInvoice",
  },
  jobs: {
    jobsdbListing: "job/jobListing/admin",
    jobsdbListingNew: "task-job/",
    jobCampaignStats: "job/jobCampaignStats",
    jobslocation: "task-job/getJobLocations",
    jobsVerticals: "verticals/getAllVerticals",
    jobCities: "worker/getDistrictByKey/v2?key=",
    workerApplied: "job/workerApplied",
    jobUpload: "upload/uploadJobs/v2",
    jobEditSave: "job/updateJobFields",
    jobEditSave2: "job/updateJobFields/v2",
    setDemandJob: "task-job/setDemandJob",
    updateJobSelection: "job/updateSelectionStatus",
    hiringFlowCreate:"hiring-flow/create",
    hiringFlowEdit:"hiring-flow/edit",
  },
  referral: {
    referralListing: "referral/dashboard",
    openClaimsListing: "referral/dashboard/openClaims",
    processedClaimsListing: "/referral/dashboard/ProcessedClaims",
    updateReferralFields: "/referral/updateFields",
  },
  bankVerification: {
    listing: "worker/bankDetailsVarification/listing",
    DetailsVerificationInitial: "worker/getBankDetailsForVerification?userId=",
    DetailsVerificationNextV2:
      "worker/getBankDetailsForVerificationv2?currentUserId=",
    submitDetails: "worker/verifiyBankDetails",
    editBankAccountDetails: "bankaccountdetail/editBankAccountDetails",
  },
  shifts: {
    shiftData: "workershift/listing",
    workerPartners: "workershift/getWorkerPartners",
    shiftStatusList: "configmaster/?category_sub_type=worker_shift_status",
    uploadEarningFlipkart: "upload/flipkartShipmentData?insertedBy=",
    uploadEarningSwiggy: "upload/swiggyShipmentData?insertedBy=",
    uploadEarningTcs: "uploadData/TCSEarningUpload?insertedBy=",
    uploadEarningZomato: "upload/zomatoShipmentData?insertedBy=",
    uploadEarningDelhivery: "upload/delhiveryShipmentData?insertedBy=",
    uploadEarningJiomart: "upload/jiomartShipmentData?insertedBy=",
    uploadEarningOther: "uploadData/newClientEarningUpload?insertedBy=",
    uploadEarningZepto: "uploadData/newZeptoEarningUpload?insertedBy=",
  },
  recruiter: {
    dashboard: "recruiter/getCountCallRecord",
    assignToRecruiter: "recruiter/assignWorkerToRecruiter",
    assignToRecruiterLead: "recruiter/assignLeadToRecruiterV2",
    activeAndBlockAPI: "recruiter/setActiveAndBlock",
  },
  verificationCases: {
    listing: "verifier/listing",
    assingedVerifier: "verifier/assignedVerifier",
    getCasesPincodeAndCity: "verifier/getCasesPincodeAndCity?",
    uploadVerificationCases:
      "uploadData/uploadExcelForVerificationCases?insertedBy=",
  },
  onHoldList:
    "configmaster/?category_sub_type=Onhold_remark&category_type=Worker_invoice",
  stateList:
    "configmaster/?category_sub_type=state_list&category_type=state_list&type_key=state_list",
  roleType: {
    leadCategory:
      "configmaster/?category_sub_type=lead_category&category_type=user_category",
    recruiterCategory:
      "configmaster/?category_sub_type=lead_category&category_type=user_category",
  },
  documentTypeList: "configmaster/?category_type=document_upload",
  entityList: "configmaster/entityList",
  onBoardingExcel:
    "user/getSignedUrlForS3Upload?filePath=document/templates/Onboarding_data.xlsx",
  onBoardingExcelV2:
    "user/getSignedUrlForS3Upload?filePath=document/templates/Onboarding_Data_Admin.xlsx",
  offBoardingExcel:
    "user/getSignedUrlForS3Upload?filePath=document/Templates/Updated_Offboarding_file_template.xlsx",
  //add here
  groupFlexExcel:
    "user/getSignedUrlForS3Upload?filePath=document/templates/Groupflex_Onboarding_Template.xlsx",
  jobdbExcel:
    "user/getSignedUrlForS3Upload?filePath=document/templates/upload_job_template.xlsx",
  projectListing: {
    mainListing: "verticals/getAllProjects",
    client: "verticals/getDataListForProject?param=1",
    getProjectsByIds: "verticals/getProjectsByIds",
    vertical: "verticals/getDataListForProject?param=2",
    projectOwner: "verticals/getDataListForProject?param=3",
    projectById: "/verticals/getProjectsById",
    addNewProject: "verticals/addNewProject",
    editProject: "/verticals/editProjectById",
    editTat: "task-model/saveTatConfig",
    saveTaskWorkflowId: "verticals/saveTaskWorkflowId",
    getAttendanceByProjectId: "verticals/getAttendanceByProjectId",
    attendanceAttributes: "verticals/attendanceAttributes",
    getAttendanceSelfieVerificationListing:
      "docsVerification/getAttendanceSelfieVerificationListing",
    getTatConfig: "task-model/getTatConfig",
    formDataList: "task-model/getALlFormDataList",
    formDataById: "task-model/getFormDataById",
    saveFormData: "/task-model/saveFormData",
  },
  driveListing: {
    mainListing: "workerdata/getDriveData",
    mainInvigilatorListing: "workerdata/getInvigilatorData",
    getFilterValues: "workerdata/driveData/getFilterValues?val=",
    getInvigilatorFilterValues:
      "workerdata/invigilatorData/getFilterValues?val=",
    saveDriveData: "workerdata/saveDriveData?projectId=",
    saveInvigilatorData: "workerdata/saveInvigilatorData",
    saveShiftUploadData: "workerdata/saveShiftUploadData",
    getInvigilatorHistory:
      "workerdata/invigilatorData/getHistory?contact_number=",
  },
  mpaListing: {
    mainListing: "task-model/mpaListing",
    AddMpaUser: "task-model/AddMpaUser",
    getAllVerticals: "verticals/getAllVerticals",
    getMpaDetailByMpaId: "task-model/getMpaDetailByMpaId?mpaId=",
    updateMpaStatus: "task-model/mpa/update-mpa-status",
  },
  leadData: {
    applicationHistory: "leaddata/getLeadApplicationHistory",
    assignAppliedLeadToRecruiter: "leaddata/assignAppliedLeadToRecruiter",
    assignLeadToOps: "leaddata/assignLeadToOps",
    assignToRecruiter: "leaddata/assignToRecruiter",
    getCampaignListing: "leaddata/getCampaignListing",
    getJobCampaignTemplates: "leaddata/getJobCampaignTemplates",
    getLeadApplicationStatus: "leaddata/getLeadApplicationStatus",
    getOpsListing: "leaddata/getOpsListing",
    getUserNotification: "leaddata/getUserNotification",
    getWorkerHistory: "leaddata/getWorkerHistory",
    mainListing: "leaddata/getLeadData",
    setLeadApplicationStatusInBulk: "leaddata/setLeadApplicationStatusInBulk",
    setRemark: "leaddata/setRemarks",
    startJobCampaign: "leaddata/startJobCampaign",
    updateLeads: "upload/updateLeads",
    uploadLeads: "upload/uploadLeads",
  },
  deeplink: {
    validateDeepLink: "deeplink/validateDeepLink",
    getDailyWhatsAppSentCount: "deeplink/getDailyWhatsAppSentCount",
  },
  payments: {
    getFinancialYearListingAmount:
      "payments/getFinancialYearListingAmount?workerId=",
  },
  accessPanelUrls: {
    mainListing: "workerdata/getRoleBasedUsers",
    addMemberForRoleAcess: "workerdata/addMemberForRoleAcess",
    dashboardPagesListing:
      "configmaster/?category_sub_type=page_name&category_type=dashboard",
    deleteMemberForRoleAcess: "workerdata/deleteMemberForRoleAcess",
    getListOfManageEmailId: "workerdata/getListOfManageEmailId?emailid=",
    roleListing:
      "configmaster/?category_sub_type=user&category_type=access_role_type",
    UpdateMemberForRoleAcess: "workerdata/UpdateMemberForRoleAcess",
    validateUser: "user/validateUser",
  },
  tcsGigUrls: {
    mainListing: "tcs/listing",
    filterMetaData: "tcs/get-filter-metadata",
    getApplicationStatus: "tcs/get-application-status-filter-metadata",
    getEmptyResourceIdData: "tcs/get-empty-resource-id-data",
    rejoinUsers: "tcs/rejoinUsers",
    updateApplicationStatus: "tcs/update-application-status",
    updateResourceId: "tcs/update-resource-id?jobId=",
    uploadExcelForTcsMpa: "/uploadData/uploadExcelForTcsMpa",
  },
  ringgaiUrls: {
    agentListing: "ringgai/get-job-agent",
    initiateCalls: "ringgai/initiate-calls-from-excel",
    jobListing: "ringgai/get-all-job-agents",
    mainListing: "ringgai/get-job-assignments",
    viewHistory: "ringgai/view-history",
  }
};

export default UrlLinks;
